import _ from 'lodash';

export default angular
  .module('doxy.common.filters.capitalize', [])
  .filter('capitalize', function () {
    return function (input) {
      if (!input) return '';
      return _.capitalize(input);
    };
  }).name;
